import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { SharedService } from '../../services/other/shared.service';
import { TransactionsSecondService } from '../../services/transaction/transactions-second.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-modal-booking-down-payment',
  templateUrl: './modal-booking-down-payment.component.html',
  styleUrls: ['./modal-booking-down-payment.component.scss'],
  providers: [DatePipe],
})
export class ModalBookingDownPaymentComponent implements OnInit {

  public BookingId: number;
  public PaymentMainPage: boolean = true;
  @Output() DoneAdd = new EventEmitter();

  constructor(
    public activeModal: NgbActiveModal,
    public translate: TranslateService,
    public sharedService: SharedService,
    public _transactionsSecondService: TransactionsSecondService,
    public datepipe: DatePipe,
    public toaster: ToastrService
  ) { }

  ngOnInit(): void {

  }

  DoneAddMethod() {
    this.DoneAdd.emit(true);
  }

}
